import React, { useEffect } from 'react'
import useOrgJwt from '../hooks/useOrgJwt'
import cfg from '../config/billing'
import { useNavigate } from 'react-router-dom'

export default function Onboarding() {
  const { orgJwt, loading: jwtLoading } = useOrgJwt()
  const nav = useNavigate()
  useEffect(() => {
    const run = async () => {
      const plan = JSON.parse(localStorage.getItem('selectedPlan') || 'null')
      if (!plan) { nav('/pricing', { replace: true }); return }
      if (jwtLoading) return
      if (!orgJwt) { nav('/sign-in-gate', { replace: true }); return }
      const h = { 'Content-Type':'application/json', Authorization: `Bearer ${orgJwt}` }
      const r1 = await fetch(`${cfg.apiBase}/billing/create-customer`, { method:'POST', headers: h })
      if (!r1.ok) { nav('/billing/error'); return }
      if (plan.tier === 'free') {
        const r2 = await fetch(`${cfg.apiBase}/billing/start-free`, { method:'POST', headers: h, body: JSON.stringify({ priceId: plan.priceId }) })
        if (r2.ok) { nav('/dashboard', { replace: true }) } else { nav('/billing/error') }
        return
      }
      const origin = window.location.origin
      const r3 = await fetch(`${cfg.apiBase}/billing/create-checkout-session`, { method:'POST', headers: h, body: JSON.stringify({ priceId: plan.priceId, successUrl: cfg.successUrl(origin), cancelUrl: cfg.cancelUrl(origin) }) })
      if (!r3.ok) { nav('/billing/error'); return }
      const { url } = await r3.json()
      window.location.href = url
    }
    run()
  }, [orgJwt, jwtLoading, nav])
  return <div style={{ display:'grid', placeItems:'center', minHeight:'50vh' }}>Setting up billing…</div>
}
